import { Helmet } from "react-helmet-async";
import { Container } from "@mui/material";
import FeedbackFormList from "src/components/Process-Associate-MIS/FeedbackForm/FeedbackForm-list";

export default function ProcessAssociateFeedbackForms() {
  return (
    <>
      <Helmet>
        <title> Feedback Forms </title>
      </Helmet>

      <Container maxWidth="xl">
        <FeedbackFormList />
      </Container>
    </>
  );
}
